import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { IconSearchAutocompleteModule } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.module';

import { MetricInfoModalComponent } from './components/metric-info-modal/metric-info-modal.component';
import { MultiMetricByCategoryListComponent } from './components/multi-metric-by-category-list/multi-metric-by-category-list.component';
import { MultiMetricSelectorModalComponent } from './components/multi-metric-selector-modal/multi-metric-selector-modal.component';
import { SingleMetricByCategoryListComponent } from './components/single-metric-by-category-list/single-metric-by-category-list.component';
import { SingleMetricSelectorModalComponent } from './components/single-metric-selector-modal/single-metric-selector-modal.component';
import { GetCategoryScrollIdPipe } from './pipes/get-category-scroll-id.pipe';
import { GetCategoryTopScrollIdPipe } from './pipes/get-category-top-scroll-id.pipe';
import { GetMetricScrollIdPipe } from './pipes/get-metric-scroll-id.pipe';
import { IsItemSelected } from './pipes/is-item-selected.pipe';
import { IsSubmenuItemSelected } from './pipes/is-submenu-item-selected.pipe';
import { IsSectionItemSelected } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/is-section-item-selected.pipe';

@NgModule({
    declarations: [
        GetCategoryScrollIdPipe,
        GetCategoryTopScrollIdPipe,
        GetMetricScrollIdPipe,
        IsItemSelected,
        IsSectionItemSelected,
        IsSubmenuItemSelected,
        MetricInfoModalComponent,
        MultiMetricByCategoryListComponent,
        MultiMetricSelectorModalComponent,
        SingleMetricSelectorModalComponent,
        SingleMetricByCategoryListComponent,
    ],
    imports: [CommonModule, FeatureNeededModule, IconModule, IconSearchAutocompleteModule, ModalBaseModule],
    exports: [SingleMetricSelectorModalComponent, MultiMetricSelectorModalComponent],
    providers: [GetCategoryScrollIdPipe, GetCategoryTopScrollIdPipe, GetMetricScrollIdPipe],
})
export class MetricSelectorModalModule {}
